module.exports = __webpack_public_path__ + "img/Line 736.f0874eff.png";